import { defineComponent, ref, onMounted, onUnmounted, watch, watchEffect, computed } from "vue";
import Input from "../Input/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DatepickerPC",
  props: {
    modelValue: null
  },
  emits: ["input"],
  setup(__props, { emit }) {
    var _a, _b;
    const props = __props;
    const showPicker = ref(false);
    const selectedDate = ref(props.modelValue || /* @__PURE__ */ new Date());
    const currentYear = ref((_a = selectedDate.value) == null ? void 0 : _a.getFullYear());
    const currentMonth = ref(((_b = selectedDate.value) == null ? void 0 : _b.getMonth()) + 1);
    const pickerRef = ref(null);
    const closeOnOutsideClick = (event) => {
      if (!pickerRef.value.contains(event.target)) {
        showPicker.value = false;
      }
    };
    const togglePicker = () => {
      showPicker.value = !showPicker.value;
    };
    onMounted(() => {
      window.addEventListener("click", closeOnOutsideClick);
    });
    onUnmounted(() => {
      window.removeEventListener("click", closeOnOutsideClick);
    });
    watch(
      selectedDate,
      (newValue) => {
        emit("input", newValue);
      },
      { immediate: true }
    );
    watch(
      () => props.modelValue,
      (newValue) => {
        if (!newValue) return;
        selectedDate.value = newValue;
        currentMonth.value = selectedDate.value.getMonth() + 1;
        currentYear.value = selectedDate.value.getFullYear();
      },
      { immediate: true }
    );
    const changeMonth = (value) => {
      currentMonth.value += value;
      if (currentMonth.value === 0) {
        currentMonth.value = 12;
        currentYear.value -= 1;
      } else if (currentMonth.value === 13) {
        currentMonth.value = 1;
        currentYear.value += 1;
      }
    };
    const selectDate = (date) => {
      if (isPast(date)) {
        return;
      }
      selectedDate.value = date;
      showPicker.value = false;
    };
    const days = ref([]);
    const updateDays = () => {
      const daysArray = [];
      const firstDay = new Date(
        currentYear.value,
        currentMonth.value - 1,
        1
      ).getDay();
      const daysInMonth = new Date(
        currentYear.value,
        currentMonth.value,
        0
      ).getDate();
      const daysInPrevMonth = new Date(
        currentYear.value,
        currentMonth.value - 1,
        0
      ).getDate();
      for (let i = daysInPrevMonth - firstDay + 1; i <= daysInPrevMonth; i++) {
        const date = new Date(currentYear.value, currentMonth.value - 2, i);
        daysArray.push({
          id: date.toISOString(),
          label: i,
          date,
          otherMonth: true
        });
      }
      for (let i = 1; i <= daysInMonth; i++) {
        const date = new Date(currentYear.value, currentMonth.value - 1, i);
        daysArray.push({
          id: date.toISOString(),
          label: i,
          date,
          otherMonth: false
        });
      }
      const remainingDays = 35 - daysArray.length;
      if (remainingDays > 0) {
        for (let i = 1; i <= remainingDays; i++) {
          const date = new Date(currentYear.value, currentMonth.value, i);
          daysArray.push({
            id: date.toISOString(),
            label: i,
            date,
            otherMonth: true
          });
        }
      }
      days.value = daysArray.slice(0, 35);
    };
    watchEffect(() => {
      updateDays();
    });
    const formattedDate = computed(
      () => `${selectedDate.value.getFullYear()}-${selectedDate.value.getMonth() + 1}-${selectedDate.value.getDate()}`
    );
    const isSelected = (date) => date.toISOString() === selectedDate.value.toISOString();
    const isToday = (date) => {
      const today = /* @__PURE__ */ new Date();
      return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate();
    };
    const isPast = (date) => {
      const today = /* @__PURE__ */ new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    };
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return { __sfc: true, props, emit, showPicker, selectedDate, currentYear, currentMonth, pickerRef, closeOnOutsideClick, togglePicker, changeMonth, selectDate, days, updateDays, formattedDate, isSelected, isToday, isPast, weekdays, TuiInput: Input };
  }
});
export {
  _sfc_main as default
};
